import type { AnyRoute, RouterOptions } from '@tanstack/react-router';

// Router options shared by the app router and the route tests that mount real routes in a router of their own.
export const routerOptions = {
  defaultPreload: 'intent',
  notFoundMode: 'root',
  scrollRestoration: true,
} satisfies Partial<RouterOptions<AnyRoute, 'never'>>;
